import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { deleteAllUsers } from '@spectee/graphql/mutations';

const document = gql(deleteAllUsers);

export function useDeleteAllUsers() {
  return useMutation(document);
}
